var exports = {
  "d1": "TagLabel__iud1Qy",
  "D_": "DeploymentIcon__Qw4U7q",
};

module.exports = exports;
